import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PondooStatusBarSlice {
  optimizedStatusLabel?: string;
  isPondooPlanReady: boolean;
}

const initialState: PondooStatusBarSlice = {
  isPondooPlanReady: false,
};

const pondooStatusBarSlice = createSlice({
  name: "pondoo-status-bar-slice",
  initialState,
  reducers: {
    setOptimizedStatusLabel(state, action: PayloadAction<string>) {
      state.optimizedStatusLabel = action.payload;
    },
    setIsPondooPlanReady(state, action: PayloadAction<boolean>) {
      state.isPondooPlanReady = action.payload;
    },
  },
});

export const { setOptimizedStatusLabel, setIsPondooPlanReady } =
  pondooStatusBarSlice.actions;

export default pondooStatusBarSlice.reducer;
